import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import homeHeaderPng from '../../../images/png/homeHeader.png';
import Typewriter from 'typewriter-effect';

const HomeHeader = () => {
    return (
        <div className="row d-flex align-items-center">
            <div className="col-md-6 text-md-start text-center pb-2">
                <h4 data-aos="fade-up" data-aos-duration="1000" className="style-font">Time To party</h4>
                <h1 data-aos="fade-up" data-aos-duration="1500" className="fw-bolder">
                    Organization <br />
                    <span style={{ fontSize: 20, padding: '0 3px', border: '2px solid gray', borderRadius: 5, color: '#ff3465' }}>of</span> company <br />
                    <span style={{ color: '#ff3465' }}>
                        <Typewriter
                        options={{
                            strings: ['Bachelorette parties', "New Year's Eve parties", "Birthday parties", "Corporate events"],
                            autoStart: true,
                            loop: true,
                        }}
                    />
                    </span>
                    
                </h1>
                <p data-aos="fade-up" data-aos-duration="2000" >Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime magnam eum dicta, nobis delectus nesciunt.</p>
                <Link data-aos="fade-up" data-aos-duration="2500"  to="/contact" className="btn rounded-pill me-2 btn-global-style-solid">
                    Book event <FontAwesomeIcon icon={faArrowRight} />
                </Link>
                <Link data-aos="fade-up" data-aos-duration="2500" to="/offer" className="btn rounded-pill btn-global-style">
                    See events <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            </div>
            <div className="col-md-6">
                <img data-aos="fade-up" data-aos-duration="3000" className="w-100" src={homeHeaderPng} alt="" />
            </div>
        </div>
    );
};

export default HomeHeader;